import { IsAllow } from "../../utils/allowHelper/AllowHelper";
import { PERMISSION_CODE } from "../../utils/enum/enums";
import Can from "../can/Can";

const ClientsFilters = ({
  category,
  search,
  categoryOptions,
  onCategoryChange,
  onSearchChange,
  onNewCustomer,
  onImport,
  translate,
  allow,
}) => {
  return (
    <div className="grid gap-6 mb-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 mt-2 mx-2">
      <div>
        <label
          htmlFor="category"
          className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
        >
          {translate("filter-by-category")}
        </label>
        <select
          id="category"
          value={category}
          onChange={(e) => onCategoryChange(e.target.value)}
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
        >
          <option value="all">{translate("all")}</option>
          {categoryOptions.map((option) => (
            <option key={option.key} value={option._id}>
              {option.name}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label
          htmlFor="search"
          className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
        >
          {translate("search")}
        </label>
        <input
          type="text"
          id="search"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={`${translate("search")}...`}
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
        />
      </div>

      {/* Botones */}
      <Can permissions={[PERMISSION_CODE.CREATE_CUSTOMER]}>
        <div className="flex justify-end items-end space-x-2">
          <button
            type="button"
            className="text-white bg-gradient-to-r from-green-400 via-green-500 to-green-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5"
            onClick={onNewCustomer}
          >
            {IsAllow(allow, "customer-02")
              ? translate("new-shop")
              : translate("new-customer")}
          </button>
          <button
            type="button"
            className="text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5"
            onClick={onImport}
          >
            {translate("import")}
          </button>
        </div>
      </Can>
    </div>
  );
};

export default ClientsFilters;
